function mobileNavigation() {

    const buttons = document.querySelectorAll(".nav a");
    for (const button of buttons) {
        button.addEventListener('click', function (event) {
            //...
            event.classList.toggle('toggled');
            alert();

            if ($(window).width() <= 767) {
                document.querySelector('.navbar-toggle').click(); //bootstrap 3.x by Richard
            }
        })
    }

}


function navigation() {

    const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));
    window.addEventListener('click', (ev) => {

        const elm = ev.target;
        if (triggers.includes(elm) === false) {
            const selector = elm.getAttribute('data-target');
            collapse(selector, 'toggle');
            //elm.closest('#navbar').classList.add('show');
        }
        if( elm.closest('#navbar')) {
            elm.closest('#navbar').classList.remove('show');
        }
    }, false);


    const fnmap = {
        'toggle': 'toggle',
        'show': 'add',
        'hide': 'remove'
    };
    const collapse = (selector, cmd) => {
        const targets = Array.from(document.querySelectorAll(selector));
        targets.forEach(target => {
            target.classList[fnmap[cmd]]('show');
        });
    }
};


document.addEventListener("DOMContentLoaded", navigation());
document.addEventListener("DOMContentLoaded", mobileNavigation());

